import { createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44a41c2e")

_pushScopeId("data-v-44a41c2e")
const _hoisted_1 = {
  class: "auto_wrap",
  style: {"display":"none"}
}
const _hoisted_2 = { class: "tit_area" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "result_tit" }, "최근 검색", -1)
const _hoisted_4 = { class: "result_lst" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "ico_del" }, "삭제", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("button", {
        onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$.emit('delete-recent-search-word', 'Y')), ["prevent"])),
        type: "button",
        class: "btn_result_del"
      }, "전체 삭제 ", 32)
    ]),
    _createVNode("ul", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recentSearchWordList, (recentSearchWord, index) => {
        return (_openBlock(), _createBlock("li", {
          key: index,
          class: "lst_item"
        }, [
          _createVNode("a", {
            href: "#",
            onMousedown: _withModifiers(($event: any) => (_ctx.$.emit('click-recent-search-word', recentSearchWord)), ["prevent"]),
            class: "txt"
          }, _toDisplayString(recentSearchWord), 41, ["onMousedown"]),
          _createVNode("button", {
            onMousedown: _withModifiers(($event: any) => (_ctx.$.emit('delete-recent-search-word', 'N', recentSearchWord)), ["prevent"]),
            type: "button",
            class: "btn_del"
          }, [
            _hoisted_5
          ], 40, ["onMousedown"])
        ]))
      }), 128))
    ])
  ]))
})